import { isCarvanaNativeApp } from '@carvana/core-native-messaging';
import { CarvanaHeader, getHeaderManifest } from '@carvana/header';
import '@carvana/header/styles.css';
import { MfeLoad } from '@carvana/microfrontend';
import { MfeReactComponent } from '@carvana/microfrontend-react';
import { useEffect } from 'react';
import { useGlobalStore } from '@/stores/global-store';
import { getEnvironment } from '@/utils/getEnvironment';
import styles from './Header.module.css';

const HeaderContent = () => {
  const setHeaderLoaded = useGlobalStore((state) => state.setHeaderLoaded);

  useEffect(() => {
    void MfeLoad({
      files: [
        [
          'HeaderModule',
          [
            {
              component: 'default',
              default: {
                file: 'index.js',
                manifest: getHeaderManifest(getEnvironment()) ?? undefined,
              },
            },
          ],
        ],
      ],
    });
  }, []);

  return (
    <MfeReactComponent
      component="default"
      module="HeaderModule"
      className={styles.header}
      loading={<CarvanaHeader />}
      onComponentLoaded={() => {
        setHeaderLoaded(true);
      }}
    />
  );
};

export const Header = () => {
  if (isCarvanaNativeApp()) return null;

  return <HeaderContent />;
};
